import React, { useMemo, useState } from 'react';
import Icon from '../../../components/AppIcon';
import { cn } from '../../../utils/cn';

export default function StarRating({
  value,
  average,
  count,
  onRate,
  disabled = false,
}: {
  value?: number | null;
  average: number;
  count: number;
  onRate?: (stars: number) => void;
  disabled?: boolean;
}) {
  const [hover, setHover] = useState<number | null>(null);

  const displayed = hover ?? (value ?? 0);
  const avgText = useMemo(() => {
    if (!count) return 'Fără voturi';
    return `${average.toFixed(1)} (${count})`;
  }, [average, count]);

  return (
    <div className="flex items-center gap-2">
      <div
        className={cn('flex items-center gap-0.5', disabled && 'opacity-60')}
        onMouseLeave={() => setHover(null)}
      >
        {Array.from({ length: 5 }).map((_, idx) => {
          const star = idx + 1;
          const active = star <= displayed;
          return (
            <button
              key={star}
              type="button"
              className={cn(
                'p-0.5 rounded hover:bg-muted transition-colors',
                disabled && 'pointer-events-none'
              )}
              aria-label={`Votează ${star} stele`}
              onMouseEnter={() => setHover(star)}
              onClick={() => onRate?.(star)}
            >
              <Icon
                name="Star"
                size={16}
                className={cn(active ? 'text-warning' : 'text-muted-foreground')}
              />
            </button>
          );
        })}
      </div>
      <div className="text-xs text-muted-foreground">{avgText}</div>
    </div>
  );
}

